declare function Page_ClientValidate(validationGroup?: string): boolean;
$(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get("returnurl");
    if (returnUrl?.toLowerCase().includes('/checkout')) {
        let loginService = $('.dnnForm.dnnLoginService');
        if (loginService.length) {
            let checkoutRow = $('<div>').addClass('dnnFormItem');

            let checkoutButton = $('<a href="/Site-Access/Guest-Checkout">').addClass('btn btn-invert-primary');
            let checkoutText = $('<span>').text('Checkout as guest');
            let checkoutArrow = $('<i>').addClass('fas fa-chevron-right');

            checkoutButton.append(checkoutText);
            checkoutButton.append(checkoutArrow);

            checkoutRow.append(checkoutButton);

            loginService.append(checkoutRow);
        }
    }

    if ($('.guest-checkout button.submitbutton[id$=btnSubmit]').length > 0) {
        $('.guest-checkout button.submitbutton[id$=btnSubmit]').on("click", function () {
            if (Page_ClientValidate()) {
                $(this).prop("disabled", true);
            }
        })
    }
});